import { useMemo } from 'react';
import { useRouteLoaderData } from 'react-router-dom';

export default function useAllowedRoutes(base, items) {
  const authData = useRouteLoaderData('auth');

  const allowedLinks = useMemo(() => {
    if (!authData || !authData.me) {
      return [];
    }

    const { superuser, apps, deployments, me } = authData;

    const activeDeployments = deployments.filter(
      (dep) => dep.status === 'active',
    );

    const userSlugs = apps
      .filter((app) =>
        activeDeployments.some((dep) =>
          me.subscriptions.some(
            (sub) => sub.deploymentId === dep._id && dep.app === app._id,
          ),
        ),
      )
      .map((app) => app.paths)
      .flat();

    const tenantSlugs = apps
      .filter((app) => activeDeployments.some((dep) => dep.app === app._id))
      .map((app) => app.paths)
      .flat();

    let slugs = userSlugs;
    if (superuser) {
      slugs = tenantSlugs;
    }

    const isObjectId = (slug) =>
      typeof slug === 'string' && /^[a-f\d]{24}$/i.test(slug);

    const filteredItems =
      base === '/admin'
        ? items
        : base === '/organizer'
          ? items.filter((item) => {
              if (item.expanded || item.subitems) {
                return item.subitems.some((subitem) =>
                  slugs.includes(`${base}/${subitem.slug}`),
                );
              }
              return (
                slugs.includes(`${base}/${item.slug}`) ||
                isObjectId(item.slug) ||
                item.slug === 'create-new'
              );
            })
          : slugs.includes(`${base}/`)
            ? items.filter((item) => {
                if (item.expanded || item.subitems) {
                  return item.subitems.some((subitem) =>
                    slugs.includes(`${base}/${subitem.slug}`),
                  );
                }
                return (
                  item.slug === '' || slugs.includes(`${base}/${item.slug}`)
                );
              })
            : slugs.includes(base)
              ? items
              : items.filter((item) => slugs.includes(`${base}/${item.slug}`));

    return filteredItems;
  }, [authData, base, items]);

  return allowedLinks;
}
